import {
  Client,
  Reservation,
  ReservationService,
  TourAgency,
  TourStandard,
  TourTypeInitials,
} from "@/models";
import moment from "moment";

export function generateReservationLabel(
  reservation: Reservation,
  tourAgency: TourAgency | undefined | null,
  groupLeader: Client | undefined | null,
  withYear = false,
) {
  const year =
    reservation.begin && withYear
      ? moment(reservation.begin).format("YY-MM-DD")
      : undefined;
  const brand = tourAgency?.agency?.name;
  const tourName = tourAgency?.tour?.name;
  const type = tourAgency?.tour?.type;
  const tailorMade =
    reservation.tourStandart === TourStandard.TailorMade
      ? "Tailor made"
      : undefined;
  const agencyReservationNumber = reservation.agencyReservationNumber
    ? `(${reservation.agencyReservationNumber})`
    : undefined;
  const groupLeaderName = groupLeader?.name;
  const details = reservation.details;

  return [
    [
      year,
      brand,
      type ? TourTypeInitials[type] : undefined,
      tailorMade,
      tourName,
      agencyReservationNumber,
    ]
      .filter(Boolean)
      .join(" "),
    [groupLeaderName, details].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(" - ");
}

export function generateReservationServiceLabel(
  reservationService: ReservationService,
  serviceName: string | undefined | null,
  providerName: string | undefined | null,
) {
  const provider = providerName
    ?.split(" ")
    .map((v) => v[0].toUpperCase())
    .filter((_, i, arr) => i === 0 || i === arr.length - 1)
    .join("");
  const textField = reservationService.notes;

  return [serviceName, provider, textField].filter(Boolean).join(" ");
}
